import(/* webpackMode: "eager" */ "/app/apps/topshop/views/delivery-and-returns/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DeliveryAndReturnsContent"] */ "/app/apps/topshop/views/delivery-and-returns/content.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/components/atoms/container/container.module.css");
;
import(/* webpackMode: "eager" */ "/app/apps/topshop/views/delivery-and-returns/index.module.css");
